import {
  RollbackIco,
  DeleteIco,
  EditIco,
  PdfIco,
  XlsIco,
  AsanIco,
  DownloadBtnIco,
  SaveBlueIco, DownloadExcel
} from '../../../../modules/CustomIcons'
import { SimaAdocActiveIcon } from '../../../../modules/SimaAdocIcons'
import i18next from '../../../../i18n'


export const statusRender = (brTrnType: string) => {
    switch (brTrnType) {
      case 'CLOSED':
        return i18next.t("transfers.executed")
      case 'PENDING_SIGNER':
        return i18next.t("transfers.forSigning")
      case 'PENDING_APPROVER':
        return i18next.t("transfers.forConfirmation")
      case 'PENDING_ALL':
        return i18next.t("transfers.signConfirmation")
      case 'SEND_TO_BANK':
        return i18next.t("transfers.inProcess")
      case 'BANK_ERROR':
        return i18next.t("transfers.notProcessed")
      case 'BANK_SUCCESS':
        return i18next.t("transfers.sentToBank")
      case 'BANK_REJECTED':
        return i18next.t("transfers.rejected")
      case 'XV':
        return i18next.t("home.foreignCurrencyTransfer")
      case 'DELETED':
        return i18next.t("transfers.deleted")
      case 'EXPIRED':
        return i18next.t("transfers.expired")
      default:
        return null
    }
  }

  export const roleRender = (brTrnType: string | null) => {
    switch (brTrnType) {
      case "2":
        return i18next.t("transfers.forMySigning")
      case "3":
        return i18next.t("transfers.forMyConfirmation")
      default:
        return ""
    }
  }

 export const renderTextforBatch = (statusValue:any)=> {
    switch (statusValue?.toString()) {
      case 'BATCH_CHECK_WAITING':
        return i18next.t('transfers.waitingForVerification')
      case 'BATCH_CHECK_ERROR':
        return i18next.t("transfers.errorsDetectedChecking")
      case 'BATCH_PAYMENTERROR':
          return i18next.t("transfers.errorsCreating")
      case 'BATCH_CHECK_START':
        return  i18next.t("transfers.checking")
      case 'BATCH_WAITING_CREATE':
        return i18next.t("transfers.waitingForCreation")
      case 'BATCH_START_CREATE':
        return 'Köçürmələr"-də yaradılır'
      case 'BATCH_FORPAYMENT':
        return i18next.t("transfers.CreatedTransfers")
      // case 'PENDING_SIGNER':
      //     return  i18next.t("transfers.forSigning") 
      case 'BANK_SUCCESS':
            return i18next.t("transfers.sentToBank") 
      case 'EXPIRED':
              return i18next.t("transfers.expired")
              case 'CLOSED':
                return i18next.t("transfers.executed")
              case 'PENDING_SIGNER':
                return   i18next.t("transfers.forSigning")
              case 'PENDING_APPROVER':
                return   i18next.t("transfers.forConfirmation")
              case 'PENDING_ALL':
                return   i18next.t("transfers.signConfirmation")
              case 'SEND_TO_BANK':
                return   i18next.t("transfers.inProcess")
              case 'BANK_ERROR':
                return   i18next.t("transfers.notProcessed")
              case 'BANK_SUCCESS':
                return   i18next.t("transfers.sentToBank")
              case 'BANK_REJECTED':
                return   i18next.t("transfers.rejected")
              case 'DELETED':
                return   i18next.t("transfers.deleted")    
      default:
        return null
    }
  }
  export const ALLOptions = [
    {
      // key: 0,
      // label: i18next.t("common.all"),
      // value: 'ALL',
      label: i18next.t("common.all"),
      // extra: 'Bütün',
      value: 'ALL',
      // status: 'Bütün'
    },
  ]
  export const dateFilter = [
    {
      label: i18next.t("common.all"),
      value: "all",
    },
    {
      label: '10.11.2021',
      value: '10.11.2021',
    },
    {
      label: '12.12.2021',
      value: '12.12.2021',
    },
    {
      label: '06.09.2022',
      value: '06.09.2022',
    },
  ]
  export const currencyFilter = [
    {
      label: i18next.t("common.all"),
      value: 'all',
    },
    {
      label: 'AZN',
      value: 'AZN',
    },
    {
      label: 'USD',
      value: 'USD',
    },
    {
      label: 'RUB',
      value: 'RUB',
    },
    {
      label: 'EUR',
      value: 'EUR',
    },
    {
      label: 'GBP',
      value: 'GBP',
    },
  ]
  export const typeFilter = [
    {
      label: i18next.t("common.all"),
      value: 'ALL',
    },
    {
      label: 'AZ',
      value: 'AZ',
    },
    {
      label: 'IM',
      value: 'IM',
    },
  ]
  export const selectStatusOptionsStatic = [
    {
      label: i18next.t("common.all"),
      value: 'ALL',
    },
    {
      label: i18next.t("transfers.signConfirmation"),
      value: 'PENDING_ALL',
    },
    {
      label: i18next.t("transfers.forConfirmation"),
      value: 'PENDING_APPROVER',
    },
    {
      label: i18next.t("transfers.forSigning"),
      value: 'PENDING_SIGNER',
    },
    {
      label: i18next.t("transfers.sentToBank"),
      value: 'BANK_SUCCESS',
    },

    {
      label: i18next.t("transfers.executed"),
      value: 'CLOSED',
    },
    {
      label: i18next.t("transfers.rejected"),
      value: 'BANK_REJECTED',
    },
    {
      label: i18next.t("transfers.deleted"),
      value: 'DELETED',
    },
    {
      label: i18next.t("transfers.expired"),
      value: 'EXPIRED',
    },
    {
      label: i18next.t("transfers.notProcessed"),
      value: 'BANK_ERROR',
    },
    {
      label: i18next.t("transfers.inProcess"),
      value: 'SEND_TO_BANK',
    },
  ]

  export const  footerBtnsFirst = [
    {
      icon: <RollbackIco />,
      title: i18next.t("home.repeat"),
      type: 'repeat',
    },
    {
      icon: <EditIco />,
      title: <div>
          <div style={{marginBottom:'10px', textAlign: "center", fontWeight: 700}}>{i18next.t("transfers.edit2")}</div>
          <div>{i18next.t("transfers.willCancelSignConfirmNotif")}</div>
             </div>,
        type: 'edit'
    },
    {
      icon: <DeleteIco />,
      title: i18next.t("transfers.delete"),
      type: 'delete'
    },
  ]

export const  footerBtnsTransferFooter = [
  {
    icon: <PdfIco />,
    title: i18next.t("transfers.downloadOrderPayment"),
    key : 'pdf',
    visible: true
  },
  {
    icon: <XlsIco />,
    title: i18next.t("transfers.downloadExcel"),
    key: 'excel',
    visible: false
  },
  {
    icon:<DownloadExcel/>,
    title:i18next.t("transfers.downloadAllExcel"),
    key:'allexcel',
    visible:true
  },
  {
    icon: <AsanIco />,
    title: i18next.t("transfers.downloadAdoc"),
    key: 'adoc',
    visible: false
  },
]

  export const  footerBtnsSecondSalary = [
    {
      icon: <PdfIco />,
      title:  i18next.t("transfers.downloadOrderPayment"),
      key : 'pdf',
      visible: true
    },
    {
      icon: <XlsIco />,
      title: i18next.t("transfers.downloadExcel"),
      key: 'excel',
      visible: false
    },
    {
      icon: <DownloadBtnIco />,
      title: i18next.t("transfers.downloadSWIFTConfirmation"),
      key: 'swift',
      visible: false
    },
    {
      icon: <AsanIco />,
      title: i18next.t("transfers.downloadAdoc"),
      key: 'adoc',
      visible: false
    },
  ]

  export const  footerBtnsSecondModal = [
    {
      icon: <PdfIco />,
      title: i18next.t("transfers.downloadOrderPayment"),
      key : 'pdf',
      visible: true
    },
    {
      icon: <DownloadBtnIco />,
      title: i18next.t("transfers.downloadSWIFTConfirmation"),
      key: 'swift',
      visible: false
    },
    {
      icon: <AsanIco />,
      title: i18next.t("transfers.downloadAdoc"),
      key: 'adoc',
      visible: false
    },
    {
      // SIMA-signed ADOC download. Only made visible when the transfer is
      // BANK_SUCCESS and was signed via SIMA; hidden otherwise. Since it only
      // ever renders for matching transfers, the active (colored) icon is used.
      icon: <SimaAdocActiveIcon className="sima-adoc-icon" />,
      title: "“SİMA İmza” sənədini endir",
      key: 'simaadoc',
      visible: false
    },
  ]

  export const  footerBtnsFirstModal = [
    {
      icon: <RollbackIco />,
      title: i18next.t("home.repeat"),
      type: 'repeat',
      visible: false
    },
    {
      icon: <EditIco />,
      title: <div>
        <div style={{marginBottom:'10px', textAlign: "center", fontWeight: 700}}>{i18next.t("transfers.edit2")}</div>
        <div>{i18next.t("transfers.willCancelSignConfirmNotif")}</div>
      </div>,
      type: 'edit',
      visible: false
    },
    {
      icon: <SaveBlueIco />,
      title: i18next.t("newTransfer.saveAsTemplate"),
      type: 'save',
      visible: false
    },
    {
      icon: <DeleteIco />,
      title: i18next.t("transfers.delete"),
      type: 'delete',
      visible: false
    },
  ]

  export const  footerBtnsSalaryModal = [
    {
      icon: <SaveBlueIco />,
      title: i18next.t("newTransfer.saveAsTemplate"),
      type: 'save',
      visible: true
    }
  ]